import { isMemberImportExecutionResponse, } from '@urbanik/api-contracts';
export class MemberImportExecutionApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'MemberImportExecutionApiError';
    }
}
export async function executeMemberImport(baseUrl, signal) {
    let response;
    try {
        response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/member-import/execution`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ confirm: true }),
            signal: signal ?? null,
        });
    }
    catch {
        throw new MemberImportExecutionApiError('unavailable', 'No pudimos ejecutar la importación.');
    }
    if (response.status === 401)
        throw new MemberImportExecutionApiError('unauthorized', 'Debes iniciar sesión.');
    if (response.status === 403)
        throw new MemberImportExecutionApiError('forbidden', 'No tienes permiso para importar.');
    let payload;
    try {
        payload = await response.json();
    }
    catch {
        throw new MemberImportExecutionApiError('invalid', 'Respuesta inválida.');
    }
    if (!response.ok || !isMemberImportExecutionResponse(payload))
        throw new MemberImportExecutionApiError('invalid', 'No se pudo confirmar el lote.');
    return payload;
}
const responseMessage = async (response, fallback) => {
    const body = (await response.json().catch(() => null));
    return typeof body?.message === 'string' ? body.message : fallback;
};
export async function downloadMemberImportTemplate(baseUrl) {
    const response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/member-import/template`, { credentials: 'include' });
    if (!response.ok)
        throw new MemberImportExecutionApiError('unavailable', await responseMessage(response, 'No pudimos descargar la plantilla.'));
    const url = URL.createObjectURL(await response.blob());
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'plantilla-socios-urbanik.xlsx';
    document.body.append(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export async function previewMemberImportFile(baseUrl, file) {
    const body = new FormData();
    body.append('file', file);
    const response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/member-import/file-preview`, { method: 'POST', credentials: 'include', body });
    if (!response.ok)
        throw new MemberImportExecutionApiError('invalid', await responseMessage(response, 'No pudimos validar la plantilla.'));
    return response.json();
}
export async function executeMemberImportFile(baseUrl, file) {
    const body = new FormData();
    body.append('file', file);
    const response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/member-import/file-execution`, { method: 'POST', credentials: 'include', body });
    if (!response.ok)
        throw new MemberImportExecutionApiError('invalid', await responseMessage(response, 'No pudimos registrar los socios.'));
    const result = await response.json();
    if (!isMemberImportExecutionResponse(result))
        throw new MemberImportExecutionApiError('invalid', 'La confirmación del registro no es válida.');
    return result;
}
